// ----------------------------------------------------------------------

const account = {
  displayName: 'EP - Aguas de Manta',
  email: 'info@epam.gob.ec',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
